<template>
    <div i="holiday">
        <el-row type="flex" justify="start">
            <el-col :span="20" style="padding:15px;">
                <el-calendar v-model="val">
                    <template
                            slot="dateCell"
                            slot-scope="{date, data}">
                        <p :class="data.isSelected ? 'is-selected' : ''">
                            {{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}
                            <span :class="{ 'holiday-flag':fmtDate(date)=='休','unholiday-flag': fmtDate(date)=='班'}">{{ fmtDate(date) }}</span>
                        </p>
                    </template>
                </el-calendar>
            </el-col>
            <el-col :span="4" style="padding:35px;">
                <el-button type="primary" @click="setHoliday(true)" class="btnHoliday">设为休假</el-button>
                <el-button type="primary" @click="setHoliday(false)" class="btnHoliday">设为上班</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {Message} from 'element-ui'
    import moment from 'moment'

    export default {
        name: "HolidayConfig",
        data() {
            return {
                value: true,
                pageIndex: 1,
                pageSize: 100,
                holidays: [],
                val: new Date()
            }
        },
        methods: {
            fmtDate(date) {
                date.setHours(0)//去时区
                console.log(date)
                if (date.getDay() == 6 || date.getDay() == 0) {
                    if (this.holidays && this.holidays.length > 0) {
                        let cfgDate = this.holidays.find(v => new Date(v.cfgDate).getTime() == date.getTime())
                        if (cfgDate && !cfgDate.isHoliday) {
                            return '班'
                        } else {
                            return '休'
                        }
                    } else {
                        return '休'
                    }
                } else {
                    if (this.holidays && this.holidays.length > 0) {
                        let cfgDate = this.holidays.find(v => new Date(v.cfgDate).getTime() === date.getTime())
                        if (cfgDate && cfgDate.isHoliday) {
                            return '休'
                        } else {
                            return '班'
                        }
                    } else {
                        return '班'
                    }
                }
            },
            loadData() {
                this.$store.dispatch("holidayConfig/getAllConfig")
                    .then(response => {
                        this.holidays = response.data.data
                        console.log(this.holidays)

                        if (this.holidays && this.holidays.length > 0) {
                            for (let i = 0; i < this.holidays.length; i++) {
                            }
                        }

                    })
            },
            setHoliday(isHoliday) {
                if (!moment().isBefore(this.val)) {
                    Message({
                        message: '不能设置过去的日期',
                        type: 'success'
                    })
                    return
                }
                this.$store.dispatch("holidayConfig/saveConfig", {
                    data: {
                        cfgDate: this.val,
                        isHoliday: isHoliday
                    }
                }).then(response => {
                    if (response.data.success) {
                        Message({
                            message: '设置成功',
                            type: 'success'
                        })
                        this.loadData()
                    }
                })
            },
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .btnHoliday {
        max-width: 410px;
        width: 100%;
        margin: 35px auto;
        display: block;
    }

    .wh_container {
        max-width: max-content;
    }

    .holiday-flag {
        padding-left: 10px;
        color: #18c79c;
    }

    .unholiday-flag {
        padding-left: 10px;
        color: indianred;
    }

</style>



// WEBPACK FOOTER //
// holidayConfig.vue?53c32b61